import * as Blockly from 'blockly/core'
import { LuaGenerator, Order } from 'blockly/lua'
import {
  BlockDefinition,
  makeMissionObjectField,
  numberInput,
  statementBlock,
  substackInput,
} from './common'

export const controlDefaults: Partial<BlockDefinition> = {
  style: 'control',
}

export const controlBlocks: Array<BlockDefinition> = [
  {
    opcode: 'control_destroy',
    generator: () => 'script.Parent:Destroy()\n',
    message0: '%{BKY_B_DESTROY}',
    previousStatement: null,
  },
  {
    opcode: 'control_forever',
    ...substackInput,
    generator: (block: Blockly.Block, generator: LuaGenerator) => {
      const substack = generator.statementToCode(block, 'SUBSTACK')
      //TODO:既存処理に戻すことがなければ消す
      // const wait =
      //   inputHasChildType(block, 'SUBSTACK', 'control_wait') ? '' : '  wait()\n'
      const wait = '  wait()\n'
      return `while true do\n${substack}${wait}end\n`
    },
    message0: '%{BKY_B_FOREVER}',
    message1: '%1',
    previousStatement: null,
  },
  {
    opcode: 'control_if',
    ...statementBlock,
    args0: [{ type: 'input_value', name: 'CONDITION', check: 'Boolean' }],
    ...substackInput,
    generator: (block: Blockly.Block, generator: LuaGenerator) => {
      const condition =
        generator.valueToCode(block, 'CONDITION', Order.NONE) || 'false'
      const substack = generator.statementToCode(block, 'SUBSTACK')
      return `if ${condition} then\n${substack}end\n`
    },
    message0: '%{BKY_B_IF}',
    message1: '%1',
  },
  {
    opcode: 'control_ifElse',
    ...statementBlock,
    args0: [{ type: 'input_value', name: 'CONDITION', check: 'Boolean' }],
    ...substackInput,
    args3: [{ type: 'input_statement', name: 'SUBSTACK2' }],
    generator: (block: Blockly.Block, generator: LuaGenerator) => {
      const condition =
        generator.valueToCode(block, 'CONDITION', Order.NONE) || 'false'
      const substack = generator.statementToCode(block, 'SUBSTACK')
      const substack2 = generator.statementToCode(block, 'SUBSTACK2')
      return `if ${condition} then\n${substack}else\n${substack2}end\n`
    },
    message0: '%{BKY_B_IF}',
    message1: '%1',
    message2: '%{BKY_B_ELSE}',
    message3: '%1',
  },
  {
    opcode: 'control_repeat',
    ...statementBlock,
    ...numberInput,
    ...substackInput,
    generator: (block: Blockly.Block, generator: LuaGenerator) => {
      const v = generator.valueToCode(block, 'VAL', Order.NONE)
      const substack = generator.statementToCode(block, 'SUBSTACK')
      return `for _ = 1,${v},1 do\n${substack}end\n`
    },
    message0: '%{BKY_B_REPEAT}',
    message1: '%1',
  },
  {
    opcode: 'control_wait',
    ...statementBlock,
    ...numberInput,
    generator: (block: Blockly.Block, generator: LuaGenerator) => {
      const v = generator.valueToCode(block, 'VAL', Order.NONE)
      return `wait(${v})\n`
    },
    message0: '%{BKY_B_WAIT}',
  },
  {
    opcode: 'control_while',
    ...statementBlock,
    args0: [{ type: 'input_value', name: 'CONDITION', check: 'Boolean' }],
    ...substackInput,
    generator: (block: Blockly.Block, generator: LuaGenerator) => {
      const conditionCode = generator.valueToCode(
        block,
        'CONDITION',
        Order.NONE,
      )
      const condition = conditionCode ? `not (${conditionCode})` : 'false'
      const substack = generator.statementToCode(block, 'SUBSTACK')
      //TODO:既存処理に戻すことがなければ消す
      // const wait =
      //   inputHasChildType(block, 'SUBSTACK', 'control_wait') ? '' : '  wait()\n'
      const wait = '  wait()\n'
      return `while ${condition} do\n${substack}${wait}end\n`
    },
    message0: '%{BKY_B_WHILE}',
    message1: '%1',
  },
  {
    opcode: 'control_clone',
    ...statementBlock,
    ...makeMissionObjectField(false),
    generator: (block: Blockly.Block) => {
      const v = block.getFieldValue('VAL')
      return `do
  local part = workspace:FindFirstChild("${v}")
  if not part then
    local serverStorage = game:GetService("ServerStorage")
    part = serverStorage:FindFirstChild("${v}")
  end
  if part then
    part:Clone().Parent = workspace
  end
end\n`
    },
    message0: '%{BKY_B_CLONE}',
  },
]
